"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconForward = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconForward = function SvgIconForward(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12422 3.74994C3.12966 3.74994 2.17583 4.14503 1.47257 4.84829C0.769312 5.55155 0.374224 6.50538 0.374224 7.49994C0.374224 8.4945 0.769312 9.44833 1.47257 10.1516C2.17583 10.8549 3.12966 11.2499 4.12422 11.2499C4.32314 11.2499 4.5139 11.1709 4.65455 11.0303C4.79521 10.8896 4.87422 10.6989 4.87422 10.4999C4.87422 10.301 4.79521 10.1103 4.65455 9.96961C4.5139 9.82896 4.32314 9.74994 4.12422 9.74994C3.52749 9.74994 2.95519 9.51289 2.53323 9.09093C2.11128 8.66897 1.87422 8.09668 1.87422 7.49994C1.87422 6.9032 2.11128 6.33091 2.53323 5.90895C2.95519 5.48699 3.52749 5.24994 4.12422 5.24994L9.06372 5.24469L7.16172 7.14594C7.02511 7.28739 6.94951 7.47684 6.95122 7.67349C6.95293 7.87014 7.0318 8.05825 7.17086 8.1973C7.30992 8.33636 7.49803 8.41524 7.69467 8.41694C7.89132 8.41865 8.08077 8.34306 8.22222 8.20644L11.4045 5.02494C11.4744 4.95545 11.5298 4.87283 11.5677 4.78183C11.6055 4.69083 11.625 4.59325 11.625 4.49469C11.625 4.39613 11.6055 4.29855 11.5677 4.20755C11.5298 4.11655 11.4744 4.03393 11.4045 3.96444L8.22222 0.782189C8.08077 0.645571 7.89132 0.569975 7.69467 0.571684C7.49803 0.573392 7.30992 0.652269 7.17086 0.791325C7.0318 0.930381 6.95293 1.11849 6.95122 1.31514C6.94951 1.51179 7.02511 1.70124 7.16172 1.84269L9.06372 3.74469L4.12422 3.74994Z",
    fill: "currentColor"
  }));
};

exports.SvgIconForward = SvgIconForward;